module.exports = __webpack_public_path__ + "img/contact-outline.8a02aa47.svg";